import { createRealtimeHooks } from '@infra/realtime';
import { coreClient } from './client';

const { useSocket, useEvent, useChannel, useBroadcast } = createRealtimeHooks(() => coreClient);

export {
  useSocket as useCoreSocket,
  useEvent as useCoreEvent,
  useChannel as useCoreChannel,
  useBroadcast as useCoreBroadcast,
};
